import { Component } from '@angular/core';

@Component({
    selector: 'app-styleguide',
    templateUrl: './styleguide.component.html',
    standalone: false
})
export class StyleguideComponent {}
